import React, { useEffect, useState } from 'react';
import {
  SlideshowData,
  SlideshowImageData,
  SlideshowImageRangeData,
} from '../../../Content';

import Carousel from 'react-material-ui-carousel';
import { useScene } from '../../../contexts/SceneContext';

interface SlideshowContentProps {
  content: SlideshowData;
}

const _generateMappedImages = (
  data: SlideshowImageRangeData
): SlideshowImageData[] => {
  const result: SlideshowImageData[] = [];

  const { min, max } = data.range;
  for (let i = min; i <= max; i++) {
    const src = data.srcPattern.replaceAll('{n}', `${i}`);
    const text = data.textPattern.replaceAll('{n}', `${i}`);
    result.push({ src, text });
  }

  return result;
};

export const SlideshowContent: React.FC<SlideshowContentProps> = ({
  content,
}) => {
  const { parseContentPath } = useScene();

  const [images, setImages] = useState<SlideshowImageData[]>([]);

  useEffect(() => {
    // Get image data for explicit images.
    const explicitImages = content.images ?? [];

    // Get image data for mapped images.
    const mappedImages = content.imageRange
      ? _generateMappedImages(content.imageRange)
      : [];

    // Parse images.
    const root = content.directory ? `${content.directory}/` : '';
    const parsedImages = [...explicitImages, ...mappedImages].map((data) => {
      return { ...data, src: parseContentPath(`${root}${data.src}`) };
    });

    // Set the images.
    setImages(parsedImages);
  }, [
    content.directory,
    content.images,
    content.imageRange,
    parseContentPath,
    setImages,
  ]);

  return (
    <Carousel
      animation="slide"
      interval={6000}
      autoPlay={true}
      navButtonsProps={{
        className: 'carousel-nav-button',
        style: { color: 'white' },
      }}
    >
      {images.map(({ src, aspect }) => (
        <div
          key={src}
          style={{
            width: '100%',
            paddingBottom: `${(aspect ?? content.aspect ?? 1) * 100}%`,
            backgroundImage: `url("${src}")`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        ></div>
      ))}
    </Carousel>
  );
};
